// extracted by mini-css-extract-plugin
export default {"card":"LZ-z","carouselContainer":"MZ-z","carouselContent":"NZ-z"};